// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1dm6H","filesListContainer":"PosDisputesFiles_filesListContainer__225mr","filesButton":"PosDisputesFiles_filesButton__3OJ8E"};